import { useEffect, useState, useRef } from "react";

import "./style.scss";
import "./../../public/css/h5vp.css";
import MyPlayer from "../public/MyPlayer";
import Overlay from "./Overlay/Overlay";
import PopupOpener from "./PopupOpener/PopupOpener";
import Video from "./Video";
import { isYoutubeURL, useWPAjax } from "../../../wp-utils/v1";
import Youtube from "./Youtube";
import isVimeoLink from "../utils/isVimeoLink";
import EndScreen from "./EndScreen/EndScreen";
import Style from "./Style";
import Vimeo from "./Vimeo";
import generateUniqueID from "../../../wp-utils/v1/generateUniqueId";

/**
 *
 * @param {attributes} props
 * @param {nonce} props
 * @returns
 */

const VideoPlayer = ({ attributes, nonce }) => {
  const { additionalCSS, additionalID, source, poster, qualities, captions, options, features, uniqueId, styles } = attributes;
  window.attributes = attributes;
  const { popup, overlay, endScreen, hideYoutubeUI } = features;
  const [player, setPlayer] = useState(null);
  const [open, setOpen] = useState(false);
  const [videoSource, setVideoSource] = useState("");
  const { autoplay, muted, loop } = options;
  const { data: isPremium, isLoading, error } = useWPAjax("pipe_handler", { nonce });

  const playerRef = useRef(null);

  useEffect(() => {
    if (player) {
      player.setIsPremium(isPremium);
    }
  }, [isPremium]);

  useEffect(() => {
    if (open) {
      player?.player.play();
    } else {
      player?.player.pause();
    }
  }, [open]);

  useEffect(() => {
    playerRef.media = playerRef.current?.querySelector("#player");
  }, [playerRef]);

  useEffect(() => {
    if (player) {
      player.destroy();
    }

    setTimeout(() => {
      const media = playerRef.current?.querySelector("#player");
      if (media && typeof media.plyr !== "object") {
        setPlayer(new MyPlayer(media, options, features));
      }
    }, 30);
  }, [options, features, videoSource, poster]);

  useEffect(() => {
    if (player && !player?.nonce) {
      player.setNonce(nonce);
    }
  }, [player]);

  useEffect(() => {
    if (!videoSource) {
      if (isYoutubeURL(source)) {
        setVideoSource("youtube");
      } else if (isVimeoLink(source)) {
        setVideoSource("vimeo");
      } else {
        setVideoSource("self-hosted");
      }
    }
  }, [source]);

  return (
    <div ref={playerRef} id={uniqueId} className={`h5vp_player_temp  ${popup.enabled ? "h5vp_popup_enabled" : ""} ${open ? "h5vp_popup_open" : ""}`}>
      <Style styles={styles} uniqueId={uniqueId} />
      <style>{additionalCSS}</style>

      {isPremium && <PopupOpener setOpen={setOpen} popup={popup} poster={poster} />}

      <div className={`plyr_wrapper ${hideYoutubeUI ? "hideUI" : ""}`} id={additionalID} data-unique-id={generateUniqueID(5)}>
        {isPremium && (
          <>
            {videoSource === "vimeo" && <Vimeo source={isVimeoLink(source)} />}
            {videoSource === "youtube" && <Youtube source={isYoutubeURL(source)} />}
          </>
        )}
        {videoSource === "self-hosted" && (
          <Video
            qualities={qualities}
            captions={captions}
            source={source}
            poster={poster}
            autoPlay={autoplay}
            muted={muted}
            loop={loop?.active}
            src={source}
            preload={options.preload}
            isPremium={isPremium}
          />
        )}
        {isPremium && (
          <>
            <EndScreen endScreen={endScreen} player={player} />
            <Overlay {...overlay} player={player?.player} />
          </>
        )}
      </div>
    </div>
  );
};

export default VideoPlayer;
